import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsMobile } from '../hooks/useIsMobile';
type PopupProps = {
    onClose: () => void;
};
type PopupPropsCustom = {
    onClose?: () => void;
    title?: string;
    children: React.ReactNode;
    footer?: React.ReactNode;
    isFullScreen?: boolean;
    customHeader?: React.ReactNode;
};

export default function Popup({ onClose }: PopupProps) {
    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    return (
        <div className="popup-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="popup active">
                <div className="popup-header">
                    <h2>Our story starts soon</h2>
                </div>
                <div className="popup-content">
                    <p>
                        CompareYachtCharters.com makes it easy to find your perfect yacht – with no bias, pressure, or hidden influence. Explore a wide range of global charter options, from the Med to the Caribbean and beyond. Our platform is fully independent, with filters that help you search by destination, yacht type, or group size. From romantic escapes to family adventures, we connect you directly with trusted providers.
                        Transparent. Independent. Effortless.
                        That’s the CompareYachtCharters.com difference.
                    </p>
                    <p>That’s the CompareYachtCharters.com difference.</p>
                </div>
                <div className="popup-footer">
                    <button className="cta outline white" type="button" onClick={onClose}>
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
}



export function PopupCustom({ onClose, title = "Popup", children, footer, isFullScreen = false, customHeader }: PopupPropsCustom) {
    const isMobile = useIsMobile();

    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && onClose) onClose();
        };
        const handlePointerDown = (e: PointerEvent) => {
            if (e.target === e.currentTarget) onClose && onClose();
        };
        document.addEventListener('keydown', handleEsc);
        document.addEventListener('pointerdown', handlePointerDown);
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.removeEventListener('pointerdown', handlePointerDown);
        };
    }, [onClose]);
    const content = (
        <div className="popup-overlay"
            style={{ zIndex: 10001 }}
            onClick={(e) => e.target === e.currentTarget && onClose && onClose()}>
            <div className={`popup custom-popup active white ${isMobile ? 'mobile' : ''} ${isFullScreen ? 'full-screen' : ''}`}>
                <div className="popup-header">
                    {customHeader ? customHeader : (
                        <>
                            <h2>{title}</h2>
                            <button onClick={onClose} type="button">
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </>
                    )}
                </div>
                <div className="popup-content">
                    {children}
                </div>
                {footer && (
                    <div className="popup-footer">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );

    const popupRoot = document.getElementById('popup-root');
    return popupRoot ? createPortal(content, popupRoot) : null;
}
